import template from 'text!./templates/currency.html';

export default [function () {
    return {
        restrict: 'E',
        scope: { item: '&' },
        template: template
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/readonly-form/Currency.js
// module id = 279
// module chunks = 0